<template>
  <div class="fzmLoginWrapper">
    <div class="container">
        
        <div class="row">
            <div class="col-md-7">
                <nav class="navbar navbar-expand-lg navbar-light">
                    <a class="navbar-brand" href=".">
                        <img src="@/assets/img/logo.svg" alt="">
                    </a>
                </nav>
                
                <div class="loginForm">
                    <h1>{{$route.name == 'login' ? 'Welcome back' : "Forgot Password"}}</h1>

                    <template v-if="$route.name == 'forgotpassword'">
                        <input 
                            v-model="loginform.email"
                            type="text" 
                            placeholder="Email" 
                            :class="['form-control inputFilled mb-3']">
                    </template>

                    <template v-else-if="$route.name == 'resetpassword'">
                        <input 
                            v-model="resetpassword.password"
                            type="password" 
                            placeholder="New password" 
                            :class="['form-control inputFilled mb-3', {'is-invalid' : resetpassword.password != resetpassword.password_confirmation}]">

                        <input 
                            v-model="resetpassword.password_confirmation"
                            type="password" 
                            placeholder="Confirm password" 
                            :class="['form-control inputFilled mb-3', {'is-invalid' : resetpassword.password != resetpassword.password_confirmation}]">

                    </template>

                    <template v-else>
                        <input 
                            v-model="loginform.email"
                            type="text" 
                            placeholder="Email" 
                            :class="['form-control inputFilled mb-3', {'is-invalid' : invalidcredential}]">

                        <input 
                            v-model="loginform.password"
                            type="password" 
                            placeholder="Password" 
                            :class="['form-control inputFilled mb-3', {'is-invalid' : invalidcredential}]">
                    </template>
    

                    <div class="row">
                        <div class="col-8">
                            <template v-if="$route.name == 'forgotpassword' || $route.name == 'resetpassword'">
                                <a 
                                @click.prevent="$router.push({name : 'login'})"
                                href="#">Already have an account? Log In</a>
                            </template>

                            <template v-else>
                                <a href="" @click.prevent="$router.push({name : 'register'})">Register</a>
                                <a href="" @click.prevent="$router.push({name : 'forgotpassword'})">Forgot Password?</a>
                            </template>
                        </div>
                        <div class="col-4">

                            <template v-if="$route.name == 'login'">
                                <button 
                                    :disabled="sending"
                                    @click.prevent="login"
                                    class="btn btn-primary">
                                    SIGN IN
                                </button>
                            </template>

                            <template v-else-if="$route.name == 'resetpassword'">
                                <button 
                                    :disabled="resetpassword.password != resetpassword.password_confirmation && sending"
                                    @click.prevent="sendresetpassword"
                                    class="btn btn-primary">
                                    Reset
                                </button>
                            </template>

                            <template v-else>

                                <button 
                                    :disabled="sending"
                                    @click.prevent="forgotpassword"
                                    class="btn btn-primary">
                                    Reset
                                </button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="col-md-5">
                <div class="loginImage">
                </div>
            </div>
        </div>
    </div>

     <b-modal 
        id="unverified" 
        hide-footer hide-header>
        <div class="d-block text-center mt-5">
            <h3><b-icon icon="person"></b-icon></h3>
            <h3>Unverified</h3>

            <p>Your account is not verified we sent new verification link to your email address <span class="emailaddress">{{loginform.email}}</span>, please check your email.</p>
            
        </div>
        <b-button 
            class="mt-4 mb-5" 
            variant="primary"  
            block 
            @click="editdeliveryday = false, $bvModal.hide('unverified')">Continue</b-button>
    </b-modal>

     <b-modal 
        id="passwordlink" 
        hide-footer hide-header>
        <div class="d-block text-center mt-5">
            <h3><b-icon icon="person"></b-icon></h3>
            <h3>Reset Password</h3>

            <p>We sent reset password link to your email address <span class="emailaddress">{{loginform.email}}</span>, please check your email.</p>
            
        </div>
        <b-button 
            class="mt-4 mb-5" 
            variant="primary"  
            block 
            @click="$bvModal.hide('passwordlink'), $router.push({name : 'login'})">Continue</b-button>
    </b-modal>
</div>
</template>

<script>
/**
 * Declerations
 */

// Plugins
import axios from 'axios'

// mixin
import {socketio} from '@/mixins/socketio'

// Helper
import Helper from '@/helpers/helper'
import {
    deleteCollection,
    newJob
    } from '@/helpers/localbase'

export default {
    mixins : [socketio],
    data() {
        return {
            loginform : {
                email   : '',
                password: ''
            },
            invalidcredential: false,
            sending          : false,
            resetpassword    : {
                password_confirmation: '',
                password             : ''
            }
        }
    },
    computed : {
        /***
         * Network status
         */
        isonline() {
            return this.$store.state.isonline
        }
    },
    methods : {
        /**
         * Reset password function
         * 
         */
        async sendresetpassword() {
                  this.sending = true;
            const url          = `submit_forgot_new_password/${this.$route.params.uid}`
            const res          = await axios.post(url, this.resetpassword).catch(err => console.log(err))
                  this.sending = false;
            
            if(res.data.success) {
                this.$router.push({name : 'login'})
            } 

        },
        /**
         * Send reset password email link
         */
        async forgotpassword() {
            this.sending = true;
            const url = "/send_reset_link_password"

            await axios.post(url, {email : this.loginform.email}).catch(err => console.log(err))

            /**
             * Sending reset link returned white space
             */
            // if(res.data.success) {
            //     }
            this.$bvModal.show('passwordlink');
            this.sending = false;
        },
        /**
         * Resets
         * this will remove cookie
         * or data from indexed db that are session base
         */
        resets() {
            /**
             * Remove active user
             */
            deleteCollection({name : 'user'})
        },
        /**
         * Authentication function
         * @param {Object} loginform
         * @returns token
         */
        async login() {
            this.sending = true;
            axios.post(`/login`, this.loginform).then( res => {
                const data = res.data;
                if(data.success) {
                    /**
                     * Check if account is verified then show popout that we sent new verification email
                     */

                    // init socket io
                    this.initsocket();

                    const user = data.data;
                    
                    if(user.roles.includes('unverified')) {
                        /**
                         * Show popout message
                         * and resend verification account
                         */
                        axios.post('/resend_email_verification', {email : this.loginform.email})
                        this.$bvModal.show('unverified');
                    } else if(user.roles.includes('customer')) {
                        /**
                       * Initiate Axios global config
                       * and set cookie
                       */
                      Helper.setCookie('holeswebtoken', data.token, 1);
                      Helper.axoisglobalconfig();
                      // Get user
                      this.$store.dispatch('getUser');
                      // Get subscription
                      this.$store.dispatch('getSubscriptions');
                      // Get settings
                      this.$store.dispatch('getsettings');
                      // Redirect to home
                      this.$router.push({name : 'home'})
                    } else {
                        this.invalidcredential = true;
                    }

                    
                } else {
                    this.invalidcredential = true;
                }
            }).catch(async () => {
                this.invalidcredential = true;
                const tag = 'sync-login';
                if(!this.isonline) {
                    /**
                     * Register background sync service worker and job
                     */
                    newJob({
                        url     : `${process.env.VUE_APP_APIROOT}/login`,
                        method  : 'POST',
                        params  : this.loginform,
                        tag     : tag,
                        callback: (data, { helper, router}) => {
                            /**
                             * Callback function that will run after api call
                             */
                            console.log('Callback login', data, router, helper);
    
                            if(data.success) {
                                /**
                                 * Initiate Axios global config
                                 * and set cookie
                                 */
                                helper.setCookie('holeswebtoken', data.token, 1);
                                helper.axoisglobalconfig();
                                router.push({name : 'home'})
                            } 
                        }
                    })
                }
            });

            this.sending = false;
        }
    },
    /**
     * Run function before component rendered
     */
    beforeMount() {
        /**
         * Resets session
         */
        this.resets();
        /**
         * Reset vuex state
         */

        this.$store.dispatch('resetstates')
    }
}
</script>

<style lang="scss">
@import '@/scss/_settings.scss';

    #unverified {
        .emailaddress {
            color      : $primary-color;
            font-weight: 700;
        }
    }

    .fzmLoginWrapper {
        .navbar {
            padding-left : 0;
        }

        .loginForm {
            .form-control {
                padding-left : 15px;
            }
        }
    }
</style>